var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    attrs: {
      "page-title": _vm.pageTitle,
      "submit-button-label": _vm.submitButtonLabel,
      "submit-button-disabled": _vm.submitButtonDisabled,
      "is-loading": _vm.loading
    },
    on: { submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "leftSideContent",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", "justify-space-between": "", wrap: "" } },
              [
                _c("div", { staticClass: "input-field-container medium" }, [
                  _c(
                    "label",
                    { staticClass: "required", attrs: { for: "name" } },
                    [_vm._v(_vm._s(_vm.$tc("Name", 1)))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.listValueData.name,
                        expression: "listValueData.name"
                      }
                    ],
                    staticClass: "input-field",
                    attrs: { id: "name", disabled: _vm.actionType === "edit" },
                    domProps: { value: _vm.listValueData.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.listValueData, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                !_vm.listValueData.custom_list
                  ? _c("div", { staticClass: "input-field-container medium" }, [
                      _c("label", { attrs: { for: "client_label" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("ClientLabel")) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.listValueData.client_label,
                            expression: "listValueData.client_label"
                          }
                        ],
                        staticClass: "input-field",
                        attrs: { id: "client_label" },
                        domProps: { value: _vm.listValueData.client_label },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.listValueData,
                              "client_label",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "input-field-container" }, [
                  _c("label", { attrs: { for: "definition" } }, [
                    _vm._v(_vm._s(_vm.$t("Definition")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.listValueData.definition,
                        expression: "listValueData.definition"
                      }
                    ],
                    staticClass: "input-field",
                    attrs: { id: "definition" },
                    domProps: { value: _vm.listValueData.definition },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.listValueData,
                          "definition",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.isSuperAdmin && !_vm.listValueData.custom_list
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "input-field-container medium radio-container"
                      },
                      [
                        _c("label", { attrs: { for: "deleted" } }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Hidden")) +
                              "\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-radio-group",
                          {
                            staticClass: "radio-group",
                            attrs: { id: "deleted", row: "", mandatory: "" },
                            model: {
                              value: _vm.listValueData.hidden,
                              callback: function($$v) {
                                _vm.$set(_vm.listValueData, "hidden", $$v)
                              },
                              expression: "listValueData.hidden"
                            }
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                disabled: _vm.listValueData.custom_list,
                                label: _vm.$t("Yes"),
                                value: true,
                                ripple: false,
                                color: "accent"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-radio", {
                              attrs: {
                                disabled: _vm.listValueData.custom_list,
                                label: _vm.$t("No"),
                                value: false,
                                ripple: false,
                                color: "accent"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSideHeader",
        fn: function() {
          return [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "row" } },
              [
                _c("management-tabs-and-search", {
                  attrs: { tabs: _vm.tabs, "open-tab": _vm.openTab },
                  on: {
                    "update-open-tab": function($event) {
                      _vm.openTab = $event
                    }
                  }
                }),
                _vm._v(" "),
                _c("management-add-button", {
                  attrs: {
                    label: _vm.$t("AddItem"),
                    "list-missing-permissions": []
                  },
                  on: { buttonClick: _vm.openListItemForm }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSideContent",
        fn: function() {
          return [
            _c(
              "v-tabs-items",
              {
                key: _vm.openTab,
                model: {
                  value: _vm.openTab,
                  callback: function($$v) {
                    _vm.openTab = $$v
                  },
                  expression: "openTab"
                }
              },
              [
                _c(
                  "v-tab-item",
                  { attrs: { value: "listItems" } },
                  [
                    _c("list-item-table", {
                      attrs: {
                        listUuid: _vm.listValueData.uuid,
                        isCustomList: _vm.listValueData.custom_list,
                        newListItems: _vm.listItems
                      },
                      on: { updateListItems: _vm.updateListItems }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("list-item-popup-form", {
              attrs: { open: _vm.listItemFormIsOpen },
              on: {
                add: _vm.newListValue,
                close: function($event) {
                  _vm.listItemFormIsOpen = false
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aefb469", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aefb469","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListForm.vue
// module id = null
// module chunks = 